import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrAlertService } from "../core/services/toastrAlert.service";
import { SweetAlertService } from "../core/services/sweet-alert.service";
import { CommonService } from "../core/services/common.service";
import { ChangePasswordService } from "../core/services/change-password.service";
import { ChangePassword } from "../core/models/nuevo-usuario";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";

@Component({
  selector: "app-recovery-password",
  templateUrl: "./recovery-password.component.html",
  styleUrls: ["./recovery-password.component.scss"],
})
export class RecoveryPasswordComponent implements OnInit {
  public password: string = "";
  public confirmPassword: string = "";
  public userCode: string = "";
  public email: string = "";
  public token: string = "";
  public textConfirm: string = "";

  public recoveryForm;
  public operation: string = "";
  public showPassword: boolean = true;
  public showConfirm: boolean = true;

  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService,
    private changePasswordService: ChangePasswordService,
    private router: Router,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    console.log(this.activatedRoute.data);
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.token = this.activatedRoute.snapshot.params.token;
    if (this.operation == "request recovery") {
      this.translateService.get("messages.recoveryPassword.request").subscribe(
        (data) => {
          this.textConfirm = data;
          this.initFormRequestRecovery();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    } else if (this.operation == "recovery") {
      this.translateService.get("messages.recoveryPassword.done").subscribe(
        (data) => {
          this.textConfirm = data;
          this.initFormRecovery();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  initFormRecovery() {
    this.recoveryForm = new FormGroup({
      userCode: new FormControl(""),
      password: new FormControl("", Validators.required),
      confirmPassword: new FormControl("", Validators.required),
      token: new FormControl(this.token),
      email: new FormControl(""),
    });
  }
  initFormRequestRecovery() {
    this.recoveryForm = new FormGroup({
      userCode: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email]),
      token: new FormControl(this.token),
      password: new FormControl(""),
      confirmPassword: new FormControl(""),
    });
  }

  onSave() {
    if (this.validations()) {
      let dto: ChangePassword = {
        usuarioId: this.recoveryForm.value["userCode"],
        email: this.recoveryForm.value["email"],
        token: this.recoveryForm.value["token"],
        password: this.recoveryForm.value["password"],
        newPassword: this.recoveryForm.value["confirmPassword"],
      };
      if (this.operation == "request recovery") {
        this.requestRecovery(dto);
      } else if (this.operation == "recovery") {
        this.recovery(dto);
      }
    }
  }

  requestRecovery(dto: ChangePassword) {
    this.sweetAlertService.sweetAlertLoading();
    this.changePasswordService.requestChangePasswordRecovery(dto).subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        this.confirmSwal.fire();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  recovery(dto: ChangePassword) {
    this.sweetAlertService.sweetAlertLoading();
    this.changePasswordService.changePasswordRecovery(dto).subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        this.confirmSwal.fire();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  validations(): boolean {
    let invalidFields = this.commonService.findInvalidControls(
      this.recoveryForm.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
      return false;
    } else {
      if (
        this.recoveryForm.value.password !=
        this.recoveryForm.value.confirmPassword
      ) {
        let message = this.translateService.instant(
          "messages.passwordConfirmationNotMatch"
        );
        this.toastrAlertService.toastrFail(message);
        return false;
      }
      return true;
    }
  }

  goLogin() {
    this.router.navigate(["/login"]);
  }

  changeView(type: string) {
    switch (type) {
      case 'password':
        this.showPassword = !this.showPassword;
        break;
      case 'confirm':
        this.showConfirm = !this.showConfirm;
        break;
      default:
        this.toastrAlertService.toastrFail('Error');
    }
  }
}
